import React, { createContext, useState, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem('authToken');
    return !!token;
  });

  const login = (token) => {
    localStorage.setItem('authToken', token);
    setIsAuthenticated(true);
    // Generar y almacenar el identificador de sesión único
    // const sessionId = uuidv4();
    // sessionStorage.setItem('sessionId', sessionId);
    // localStorage.setItem('sessionId', sessionId);
  };
  const initSession = () => {
    if (!sessionStorage.getItem('sessionId')) {
      const sessionId = uuidv4();
      sessionStorage.setItem('sessionId', sessionId);
      localStorage.setItem('sessionId', sessionId);
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('sessionId');
    localStorage.clear();
    sessionStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, initSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);